import { cn } from "~/services/shadcn";

export function Skeleton({
  className,
  active,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { active: boolean }) {
  const comp = (
    <div className={cn("animate-pulse rounded-xs bg-[#E7C5B71A]", className)} {...props} />
  );

  if (!active) return children;

  return comp;
}
